import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLeadDetails, getUsers, lead_insert, getLeadConfig, updateLead, call_p2p } from "../../../api/lead";
import { Toast } from 'bootstrap';
import NotificationToasts from '../NotificationToast';

const LeadEdit = () => {
    const location = useLocation();
    const userType = localStorage.getItem('type');
    const { lead_data, source } = location.state || {};
    const [msg, setMsg] = useState("")
    const toastRef = useRef(null);
    const navigate = useNavigate();

    const [loadingData, setLoadingData] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [leadHistory, setLeadHistory] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [assigned, setAssigned] = useState(lead_data.assigned_to || '');
    const [configuration, setConfiguration] = useState();
    const [formData, setFormData] = useState({
        name: lead_data.name || '',
        email: lead_data.email || '',
        source: lead_data.source || '',
        lead_type: lead_data.lead_type || '',
        parent_name: lead_data.parent_name || '',
        studentClass: lead_data.studentClass || '',
        course: lead_data.course || '',
        phone: lead_data.phone || '',
        city: lead_data.city || '',
        country: lead_data.country || '',
        remarks: lead_data.remarks || '',
        school: lead_data.school || '',
        assignToSelf: false,
        assigned_to: lead_data.assigned_to || '',
        status: lead_data.status || '',
        status_id: lead_data.status_id || 0,
        priority: lead_data.priority || '',
        followUpType: lead_data.followUpType || '',
        followUpDate: lead_data.followUpDate || '',
        followUpHour: '',
        followUpMinute: ''
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const types = "city,country,lead_sources,lead_types,lead_status,followup_type,priority";
                const [leadsData, agentListRes, configData] = await Promise.all([
                    getLeadDetails(lead_data.lead_id),
                    getUsers({ user_type: "Agent" }),
                    getLeadConfig(types)
                ]);
                if (leadsData.status && agentListRes.status && configData.status) {
                    setLeadHistory(leadsData.data);
                    setAgentList(agentListRes.data);
                    setConfiguration(configData.data);
                    setLoadingData(false);
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        fetchData();
    }, [lead_data.lead_id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    useEffect(() => {
      const disableCopy = (e) => e.preventDefault();
    
      document.addEventListener("copy", disableCopy);
      document.addEventListener("cut", disableCopy);
      document.addEventListener("paste", disableCopy);
      document.addEventListener("contextmenu", disableCopy);
    
      return () => {
        document.removeEventListener("copy", disableCopy);
        document.removeEventListener("cut", disableCopy);
        document.removeEventListener("paste", disableCopy);
        document.removeEventListener("contextmenu", disableCopy);
      };
    }, []);    

    const handleBookDemo = async (e) => {
        e.preventDefault();

        const {
            name, email, source, lead_type, parent_name,
            studentClass, course, phone, message, city, country,
            school, followUpDate, followUpHour, followUpMinute,
            status, status_id, priority, followUpType, remarks, assigned_to
        } = formData;

        if (!name || !phone ) {
            alert('Please fill in all required fields before submitting.');
            return;
        }

        const followUpDateTime = `${followUpDate}T${followUpHour}:${followUpMinute}:00`;
        formData['followUpDateTime'] = followUpDateTime
        formData['lead_id'] = lead_data.lead_id
        formData['status_id'] = parseInt(status_id)
        const payload = {
            ...formData,
            source: parseInt(source)
        };
        
        const response = await updateLead(payload);
        if (response.status === true && toastRef.current) {
            setMsg(response.message)
            const toast = new Toast(toastRef.current);
            toast.show();
        }

        // window.location.reload();
    };

    const handleBackClick = () => {
      navigate("/home/"+source);
    };

    const handleCallClick = async() => {
      let data = {
        "customer_number": formData.phone,
        "lead_id": lead_data.lead_id
      }

      const response = await call_p2p(data);
      if (response.status === true) {
        // setMsg("Call Initiated on Ziwo Portal.");
        setNotifications((prev) => [
          ...prev,
          { message: "Call Initiated on Ziwo Portal.", timestamp: new Date().toLocaleTimeString() },
        ]);
      } else {
        const errorMsg = response.message?.error?.message || "Something went wrong";
        // alert(errorMsg);
        setNotifications((prev) => [
          ...prev,
          { message: errorMsg, timestamp: new Date().toLocaleTimeString() },
        ]);
      }      
    }

    const removeNotification = (index) => {
      setNotifications((prev) => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
      const blurOnBlur = () => {
        document.body.classList.add("blur-sensitive");
      };
    
      const unblurOnFocus = () => {
        document.body.classList.remove("blur-sensitive");
      };
    
      window.addEventListener("blur", blurOnBlur);
      window.addEventListener("focus", unblurOnFocus);
    
      return () => {
        window.removeEventListener("blur", blurOnBlur);
        window.removeEventListener("focus", unblurOnFocus);
      };
    }, []);    

    const maskNumber = (value) => {
      if (!value) return "";
      const visibleDigits = 4;
      const maskedLength = value.length - visibleDigits;
      return "*".repeat(maskedLength) + value.slice(-visibleDigits);
    };

    return (
      <>
        <div className="mt-4 mb-4">
          <NotificationToasts
            notifications={notifications}
            removeNotification={removeNotification}
          />
          <div className="row">
            <div className="col">
              {
                source != "followups" ?<button className="btn btn-secondary" onClick={handleBackClick}>
                ← Back
              </button>: <></>
              }
              <div
                className="position-fixed top-0 end-0 p-3"
                style={{ zIndex: 1065 }}
              >
                <div
                  ref={toastRef}
                  className="toast align-items-center text-bg-success border-0"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div className="d-flex">
                    <div className="toast-body">{msg}</div>
                    <button
                      type="button"
                      className="btn-close btn-close-white me-2 m-auto"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                </div>
              </div>
              <span className="mx-4 h5">
                {lead_data.name} / L-{lead_data?.lead_id ? `*******${lead_data?.lead_id.slice(-10)}` : ''}
              </span>
            </div>
          </div>
        </div>
        <form onSubmit={handleBookDemo}>
          <div className="row">
            {/* Left Column */}
            <div className="col-7">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Source</label>
                  <select
                    className="form-select"
                    name="source"
                    value={formData.source}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {configuration?.lead_sources.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Lead Type</label>
                  <select
                    className="form-select"
                    name="lead_type"
                    value={formData.lead_type}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {configuration?.lead_types.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Basic Inputs */}
              {[
                { label: "Student Name", name: "name", type: "text" },
                { label: "Parent Name", name: "parent_name", type: "text" },
                { label: "E-mail", name: "email", type: "email" },
                { label: "School Name", name: "school", type: "text" },
                { label: "Phone No.", name: "phone", type: "tel" },
              ].map((field) => (
                <div className="mb-3" key={field.name}>
                  <label className="form-label fw-semibold">
                    {field.label}
                  </label>
                  {field.name == "phone" ? (
                    <div className='row'>
                        <div className='col'>
                        {/* <input
                          type="text"
                          className="form-control"
                          placeholder={field.label}
                          name={field.name}
                          value={maskNumber(formData[field.name])}
                          onChange={handleChange}
                          disabled
                        /> */}
                        <input
                            type={field.type}
                            className="form-control"
                            placeholder={field.label}
                            name={field.name}
                            value={formData[field.name]}
                            onChange={handleChange}
                            disabled
                        />
                        </div>
                        <div className='col'>
                            <button
                                type="button"
                                className="btn btn-success rounded-pill" onClick={handleCallClick}>
                                Call Student
                            </button>
                        </div>
                    </div>
                  ) : (
                    <input
                        type={field.type}
                        className="form-control"
                        placeholder={field.label}
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                    />
                  )}
                  {/* <input
                    type={field.type}
                    className="form-control"
                    placeholder={field.label}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                  /> */}
                </div>
              ))}

              {/* Class & Course */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Class</label>
                  <select
                    className="form-select"
                    name="studentClass"
                    value={formData.studentClass}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {[6, 7, 8, 9, 10, 11, 12].map((cls) => (
                      <option key={cls} value={`${cls}th`}>
                        {cls}th
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Course</label>
                  <select
                    className="form-select"
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {["SCHOOL", "JEE", "NEET", "Boards", "SAT"].map(
                      (course) => (
                        <option key={course} value={course}>
                          {course}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              {/* Location */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">City</label>
                  <select
                    className="form-select"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {configuration?.city.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Country</label>
                  <select
                    className="form-select"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {configuration?.country.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Remarks</label>
                <textarea
                  className="form-control"
                  rows="3"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="col-5">
              <div
                className="p-4 bg-light rounded"
                style={{ maxWidth: "600px", margin: "auto" }}
              >
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Status</label>
                    <select
                      name="status_id"
                      className="form-select"
                      value={formData.status_id}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {configuration?.lead_status.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col">
                    <label className="form-label">Priority</label>
                    <select
                      name="priority"
                      className="form-select"
                      value={formData.priority}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {configuration?.priority.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {!(formData.status === "Dead" && userType === "Agent") && (
                  <div className="mb-3">
                    <label className="form-label">Follow Up Type</label>
                    <select
                      name="followUpType"
                      className="form-select"
                      value={formData.followUpType}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {configuration?.followup_type.map((f) => (
                        <option key={f.id} value={f.id}>
                          {f.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {(userType === "Admin" || userType === "Manager") && (
                  <div className="mb-3">
                    <label className="form-label">Assigned To</label>
                    <select
                      name="assigned_to"
                      className="form-select"
                      value={formData.assigned_to}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {agentList.map((agent) => (
                        <option key={agent.id} value={agent.id}>
                          {agent.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {!(formData.status === "Dead" && userType === "Agent") && (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Follow Up Date *</label>
                        <input
                          type="date"
                          className="form-control"
                          name="followUpDate"
                          value={formData.followUpDate}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Follow Up Time *</label>
                        <div className="row">
                          <div className="col">
                            <select
                              className="form-select"
                              name="followUpHour"
                              value={formData.followUpHour}
                              onChange={handleChange}
                            >
                              <option value="">HH</option>
                              {[...Array(24).keys()].map((h) => (
                                <option
                                  key={h}
                                  value={String(h).padStart(2, "0")}
                                >
                                  {String(h).padStart(2, "0")}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col">
                            <select
                              className="form-select"
                              name="followUpMinute"
                              value={formData.followUpMinute}
                              onChange={handleChange}
                            >
                              <option value="">MM</option>
                              {[0, 15, 30, 45].map((m) => (
                                <option
                                  key={m}
                                  value={String(m).padStart(2, "0")}
                                >
                                  {String(m).padStart(2, "0")}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Comments</label>
                      <textarea
                        className="form-control"
                        name="comments"
                        rows="3"
                        value={formData.comments}
                        onChange={handleChange}
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary primary-button w-100 rounded-pill mt-2"
                    >
                      Update
                    </button>
                  </>
                )}

                <div className="container mt-4">
                  <hr />
                  <h5 className="mb-3">History</h5>
                  {leadHistory
                    ?.slice()
                    .reverse()
                    .map((history, index) => (
                      <div
                        key={index}
                        className="p-3 mb-2 border rounded bg-white shadow-sm"
                        style={{ fontSize: "0.95rem" }}
                      >
                        <div className="fw-semibold">{history?.action}</div>
                        <div
                          className="text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {history?.remarks} |{" "}
                          <span>
                            {history?.created_at?.$date
                              ? new Date(
                                  history.created_at.$date
                                ).toLocaleString()
                              : ""}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
    );
};

export default LeadEdit;